import FormattedMessage from 'I18n/components/FormattedMessage';
import { LockedIcon } from 'foundations-assets';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PermissionTooltip from 'customer-data-objects-ui-components/permissions/PermissionTooltip';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm-... Remove this comment to see the full error message
import links from 'crm-legacy-links/links';
import { useObjectLimitAndTotal } from '../../crmObjects/hooks/useObjectLimitAndTotal';
import { RESTORE, useLimitUpgradeButtonProps } from '../../upgrades/hooks/useLimitUpgradeButtonProps';
import { trackIndexInteractionsEvent } from '../../tracking/indexPageTracking';
import { useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { IARedesignSwitch } from '../../auth/components/IARedesignSwitch';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecycleBinButton = ({
  typeDef,
  hasAllScopes
}) => {
  var _buttonProps$href, _buttonProps$href2;
  const disabled = !hasAllScopes('crm-recycling-bin-access');
  const {
    limitReached
  } = useObjectLimitAndTotal();
  const {
    buttonProps
  } = useLimitUpgradeButtonProps(RESTORE);
  const onClickHandler = useCallback(() => {
    var _buttonProps$onClick;
    buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps);
    trackIndexInteractionsEvent({
      action: 'clicked restore records from action dropdown'
    });
  }, [buttonProps]);
  const gatedContent = /*#__PURE__*/_jsx(PermissionTooltip, {
    tooltipKey: "restoreObjectsDisabled.object",
    disabled: !disabled,
    children: /*#__PURE__*/_jsxs(Button, {
      disabled: disabled,
      external: true,
      "data-test-id": "recycle-bin-button",
      href: (_buttonProps$href = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps$href !== void 0 ? _buttonProps$href : links.recyclingBin(typeDef.objectTypeId),
      onClick: onClickHandler,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "topbarContents.recyclingBinNav.object"
      }), limitReached && /*#__PURE__*/_jsx(LockedIcon, {
        "data-test-id": "recycle-bin-button-lock"
      })]
    })
  });
  const ungatedContent = /*#__PURE__*/_jsx(PermissionTooltip, {
    tooltipKey: "restoreObjectsDisabled.object",
    disabled: !disabled,
    children: /*#__PURE__*/_jsx(Button, {
      disabled: disabled,
      external: true,
      "data-test-id": "recycle-bin-button",
      href: (_buttonProps$href2 = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.href) !== null && _buttonProps$href2 !== void 0 ? _buttonProps$href2 : links.recyclingBin(typeDef.objectTypeId),
      onClick: onClickHandler,
      use: "transparent",
      children: /*#__PURE__*/_jsxs(Text, {
        as: "span",
        typography: "body-100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "topbarContents.recyclingBinNav.object"
        }), limitReached && /*#__PURE__*/_jsx(LockedIcon, {
          "data-test-id": "recycle-bin-button-lock"
        })]
      })
    })
  });
  return /*#__PURE__*/_jsx(IARedesignSwitch, {
    gatedContent: gatedContent,
    ungatedContent: ungatedContent
  });
};
export default RecycleBinButton;